<template lang="pug">

div

    //- Filter
    .ui.secondary
        .ui.labels
            router-link.ui.label(:to='{ name: "jobs" }' exact)
                | Neu:
                .ui.detail {{ counts.new }}
            router-link.ui.label(:to='{ name: "jobs", query: { status: "PENDING" }}' exact)
                | Offen:
                .ui.detail {{ counts.pending }}
            router-link.ui.label(:to='{ name: "jobs", query: { status: "ACCEPTED" }}' exact)
                | Bestätigt:
                .ui.detail {{ counts.accepted }}
            router-link.ui.label(:to='{ name: "jobs", query: { status: "IN_PRODUCTION" }}' exact)
                | In Produktion:
                .ui.detail {{ counts.inProduction }}
            router-link.ui.label(:to='{ name: "jobs", query: { status: "DECLINED" }}' exact)
                | Abgelehnt:
                .ui.detail {{ counts.declined }}
            router-link.ui.label(:to='{ name: "jobs", query: { status: "COMPLETED" }}' exact)
                | Abgeschlossen:
                .ui.detail {{ counts.completed }}
            router-link.ui.label(:to='{ name: "jobs", query: { status: "ALL" }}' exact)
                | Alle:
                .ui.detail {{ counts.all }}
    //- Message wenn keine Jobs gefunden
    .ui.bottom.info.icon.message(v-if='pageJobs.length === 0')
        i.info.circle.icon
        .content: .header Keine Jobs vorhanden

    //- Content
    jobs-table.ui.segment(
        v-bind:job-models='pageJobs'
        v-bind:media-production-person-models='mediaProductionPersons'
        v-bind:media-production-user-models='mediaProductionUsers'
        v-bind:offer-models='offers'
        v-bind:product-models='products'
        v-bind:product-types='productTypes'
        v-bind:sort-ascending='sortAscending'
        v-bind:variant-models='variants'
        v-on:toggle-sort='sortAscending = !sortAscending'
        v-else
    )

    //- Pagination
    .ui.bottom.secondary(v-if='pageJobs.length > 0')
        .ui.two.column.grid
            .middle.aligned.column
                .ui.form
                    .inline.fields(style='margin: 0')
                        label Zeilen pro Seite:
                        .field
                            select.ui.selection.dropdown(ref='pageSizeDropdown')
                                option(v-for='n in pageSizeOptions' v-bind:key='n' v-bind:value='n') {{ n }}
            .right.aligned.middle.aligned.column(v-if='totalPages > 1')
                .ui.pagination.menu
                    a.icon.item(v-bind:class='{ disabled: currentPage === 1 }' v-on:click='currentPage > 1 && (currentPage -= 1)')
                        i.left.chevron.icon
                    a.item(
                        v-for='page in totalPages'
                        v-bind:key='page'
                        v-bind:class='{ active: page === currentPage }'
                        v-on:click='currentPage = page'
                    ) {{ page }}
                    a.icon.item(v-bind:class='{ disabled: currentPage === totalPages }' v-on:click='currentPage < totalPages && (currentPage += 1)')
                        i.right.chevron.icon

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import JobsTable from '@/components/jobs/Table.vue'

    function getStatus(route) {
        const status = R.pipe(R.propOr('NEW', 'status'), R.toUpper)(route.query)
        const valid = ['NEW', 'PENDING', 'ACCEPTED', 'DECLINED', 'IN_PRODUCTION', 'COMPLETED', 'ALL']
        return R.any(R.equals(status), valid) ? status : 'NEW'
    }

    async function load_page(route, { page = 0, size = 25, sortAscending = false } = {}) {
        const { jobs, totalElements } = await store.dispatch('jobs/loadPage', {
            page,
            size,
            status:      getStatus(route),
            isArchived:  false,
            setCounts:   true,
            sort:        `id,${sortAscending ? 'asc' : 'desc'}`,
        })

        const [ offerModels ] = await Promise.all([
            store.dispatch('offers/loadAllByJobModels',  { jobModels: jobs }),
            store.dispatch('persons/loadAllByJobModels', { jobModels: jobs }),
            store.dispatch('users/loadAllByJobModels',   { jobModels: jobs }),
        ])

        const variantModels = await store.dispatch('variants/loadAllByOfferModels',  { offerModels })
        const productModels = await store.dispatch('products/loadAllByVariantModels', { variantModels })
        await store.dispatch('productTypes/loadAllByProducts', { products: productModels })

        return { jobs, totalElements }
    }

    //noinspection JSUnusedGlobalSymbols
    export default {

        beforeRouteEnter(to, from, next) {
            load_page(to).then(({ jobs, totalElements }) => next(vm => {
                vm.pageJobs      = jobs
                vm.filteredTotal = totalElements
            }))
        },

        beforeRouteUpdate(to, from, next) {
            this._routeChanging = true
            this.currentPage = 1
            load_page(to, { size: this.itemsPerPage, sortAscending: this.sortAscending })
                .then(({ jobs, totalElements }) => {
                    this.pageJobs        = jobs
                    this.filteredTotal   = totalElements
                    this._routeChanging  = false
                    next()
                })
        },

        components: { JobsTable },

        created() {
            this._routeChanging = false
        },

        mounted() {
            this._initDropdown()
        },

        updated() {
            this._initDropdown()
        },

        data() {
            return {
                currentPage:     1,
                filteredTotal:   0,
                itemsPerPage:    25,
                pageJobs:        [],
                pageSizeOptions: [25, 50, 100, 250],
                sortAscending:   false,
            }
        },

        watch: {
            currentPage() {
                if (!this._routeChanging) this.loadCurrentPage()
            },
            itemsPerPage() {
                if (this.currentPage === 1) {
                    this.loadCurrentPage()
                } else {
                    this.currentPage = 1
                }
            },
            sortAscending() {
                this.loadCurrentPage()
            },
        },

        methods: {
            _initDropdown() {
                const el = this.$refs.pageSizeDropdown
                if (!el || $(el).data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        const n = parseInt(value, 10)
                        if (n !== this.itemsPerPage) {
                            this.itemsPerPage = n
                            this.currentPage = 1
                        }
                    }
                })
            },

            async loadCurrentPage() {
                const { jobs, totalElements } = await load_page(this.$route, {
                    page:          this.currentPage - 1,
                    size:          this.itemsPerPage,
                    sortAscending: this.sortAscending,
                })
                this.pageJobs      = jobs
                this.filteredTotal = totalElements
            },
        },

        computed: {

            counts() {
                return store.getters['jobs/counts']
            },

            totalPages() {
                return Math.ceil(this.filteredTotal / this.itemsPerPage)
            },

            mediaProductionUsers() {
                return store.getters['users/all']
            },

            mediaProductionPersons() {
                return store.getters['persons/all']
            },

            offers() {
                return store.getters['offers/all']
            },

            products() {
                return store.getters['products/all']
            },

            productTypes() {
                return store.getters['productTypes/all']
            },

            variants() {
                return store.getters['variants/all']
            },

        }

    }

</script>